import React from 'react';
import { Brain, BookOpen, Clock } from 'lucide-react';

const adaptations = [
  {
    icon: Clock,
    title: 'TDAH',
    features: [
      'Estratégias de foco',
      'Organização de tarefas',
      'Gerenciamento de tempo',
    ],
    color: 'from-primary to-primary-dark',
  },
  {
    icon: BookOpen,
    title: 'Dislexia',
    features: [
      'Suporte visual',
      'Leitura gradual',
      'Atividades sensoriais',
    ],
    color: 'from-secondary to-secondary-dark',
  },
  {
    icon: Brain,
    title: 'Autismo',
    features: [
      'Apoio em interpretação textual',
      'Estímulo à autonomia',
      'Ambiente acolhedor',
    ],
    color: 'from-accent to-accent-dark',
  },
];

const Adaptations = () => {
  return (
    <section id="adaptations" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Adaptações Especializadas
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Nosso método é cuidadosamente desenhado para atender às necessidades únicas
            de cada aluno, garantindo um aprendizado efetivo e personalizado.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {adaptations.map((item) => (
            <div
              key={item.title}
              className="relative overflow-hidden rounded-2xl shadow-xl transform transition-transform hover:-translate-y-2"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${item.color} opacity-90`} />
              <div className="relative p-8">
                <item.icon className="h-12 w-12 text-white mb-6" />
                <h3 className="text-2xl font-bold text-white mb-4">{item.title}</h3>
                <ul className="space-y-3">
                  {item.features.map((feature, index) => (
                    <li key={index} className="flex items-center text-white">
                      <span className="mr-2">•</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="#contact"
            className="inline-block px-8 py-4 bg-accent text-white rounded-full text-lg font-semibold hover:bg-accent-dark transition-colors"
          >
            Saiba como o PDTE pode ajudar seu filho
          </a>
        </div>
      </div>
    </section>
  );
};

export default Adaptations;